<!-- Nebular layout removed - this component is deprecated and no longer used -->
<div class="layout-container">
    <!-- Empty placeholder - component kept for backwards compatibility -->
</div>